import { buildStatsSections } from '../../utils/stats';
import EntryContext from './EntryContext';
import StatsSections from './StatsSections';

function UsageTab({ entry, session }) {
    const sections = buildStatsSections(entry ? entry.stats : null, session);

    return (
        <>
            {entry && <EntryContext entry={entry} />}
            {sections.length === 0 &&
                <div className="ai_chat_panel_stats_empty">No AI call yet. Usage details appear here after your first request.</div>
            }
            <StatsSections sections={sections} />
        </>
    );
}

export default UsageTab;
